import React from 'react';
import { BODY, ink } from '../../primitives.js';

const h = React.createElement;

const TILE_TINTS = ['var(--lime-bg)', 'var(--gold-bg)', 'var(--coral-bg)', 'var(--blu-bg)', 'var(--pur-bg)'];

/**
 * Honest two-letter monogram for a third-party app on a hashed tint. Never an invented logo.
 *
 * @param {object} p
 * @param {string} [p.app]
 * @param {number} [p.size]
 * @param {string} [p.title]
 * @param {React.CSSProperties} [p.style]
 */
export function MonoTile({ app = '', size = 20, title, style }) {
  let s = 0; for (const c of app) s = (s * 31 + c.charCodeAt(0)) >>> 0;
  const words = app.trim().split(/\s+/), mono = (words.length > 1 ? words[0][0] + words[1][0] : app.slice(0, 2)).toUpperCase();
  return h('span', { title: title || app, style: { display: 'inline-grid', placeItems: 'center', width: size, height: size, borderRadius: Math.max(5, Math.round(size * .3)), background: TILE_TINTS[s % TILE_TINTS.length], color: 'var(--ink)', border: ink(1.5), boxSizing: 'border-box', fontFamily: BODY, fontWeight: 800, fontSize: Math.max(8, Math.round(size * .4)), flex: 'none', ...style } }, mono);
}
